<script lang="ts">
	import Icon from '../../icon/Icon.svelte'
	import { formInputClass } from '../../styles'
	import { _ } from '@repo/i18n'
	import { MagnifyingGlass } from '@steeze-ui/heroicons'
	import { onMount, tick } from 'svelte'

	interface Props {
		value: string
		oninput: () => void
	}

	let { value = $bindable(), oninput }: Props = $props()

	let searchInput: HTMLInputElement = $state(null)

	onMount(async () => {
		await tick()
		searchInput.focus()
	})
</script>

<div class="relative">
	{#if !value}
		<div
			class="t-0 pointer-events-none absolute right-0 flex h-full items-center pr-3 text-gray-400"
		>
			<Icon src={MagnifyingGlass} />
		</div>
	{/if}
	<input
		bind:this={searchInput}
		class="{formInputClass} w-full appearance-none border-b border-b-gray-200 dark:border-b-gray-500"
		maxlength="30"
		placeholder={$_('input.search')}
		type="search"
		bind:value
		{oninput}
	/>
</div>
